import './FileButton.css';
import { useTranslation } from 'react-i18next';

function FileButton({ filename, onDelete, index, width = '100%', showDelete = true }) {
  const { t: tCommon } = useTranslation('common');

  return (
    <div className='assistant-file-item' key={index} style={{ width }}>
      <div className='icon-ext' key={index}>
        {(() => {
          const ext = filename.split('.').pop().toLowerCase();

          if (ext === 'pdf') {
            return <img src="/imagens/pdf.svg" alt={tCommon("pdfFile")} />;
          } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
            return <img src="/imagens/image.svg" alt={tCommon("imageFile")} />;
          } else if (['xls', 'xlsx'].includes(ext)) {
            return <img src="/imagens/xls.svg" alt={tCommon("excelFile")} />;
          } else {
            return <img src="/imagens/file.svg" alt={tCommon("genericFile")} />;
          }
        })()}
        
      </div>
      <div className="assistant-file-name" style={{ width: `calc(${width} - 40px)` }}>{filename}</div>
      {showDelete && (
        <img
          src="/imagens/x.svg"
          alt={tCommon("deleteIcon")}
          className="delete-file-icon"
          onClick={onDelete}
        />
      )}
    </div>
  );
}

export default FileButton;
